@if (dialogRef) {
<div mat-dialog-title>
  @if (!error.overlayConfig?.hideCloseButton) {
  <button
    id="close-btn"
    mat-icon-button
    mat-dialog-close
    class="close-btn"
    [title]="'ARIA_LABEL.DIALOG.CLOSE' | translate"
    [attr.aria-label]="'ARIA_LABEL.DIALOG.CLOSE' | translate"
  >
    <mat-icon>close</mat-icon>
  </button>
  }
</div>
}

<div class="content text-center">
  @if (error.heading) {
  <h1 id="main_error_heading" class="mt-8">{{ error.heading | translate }}</h1>
  } @if (error.title) {
  <h2 id="main_error_title">{{ error.title | translate }}</h2>
  } @if (error.image) {
  <img id="main_error_icon" class="error_img" [src]="error.image | translate" alt="" />
  } @else if (error.svg) {
  <div class="error_img_container">
    <pbb-svg-icon [icon]="error.svg" class="error_img" alt=""></pbb-svg-icon>
  </div>
  } @else {
  <div class="error_img_container">
    <mat-icon id="main_error_icon" class="icon-xlg mt-11 mb-9">{{ error.icon || 'error_outline' }}</mat-icon>
  </div>
  }

  <div
    id="main_error_message"
    class="mat-body-2 mt-24 error-message"
    [class.mb-24]="!error.buttons && hideCloseButton"
    [innerHTML]="error.message | translate"
  ></div>

  <div appStickyButton="#footer" class="sticky-container">
    <div class="sticky-main flex-col-center flex-gap-10">
      @if (!error.buttons && !hideCloseButton) {
        <pbb-button [pbbButtonType]="'secondary'" [id]="'close-btn'" (click)="closeKonek()">
          {{ 'COMMON.BUTTON.RETURN_TO_MERCHANT' | translate }}
        </pbb-button>

      } @if (error.buttons && error.buttons.length) {
        @for (button of error.buttons; track button; let i = $index) {
        <pbb-button [pbbButtonType]="button.konekColor" [id]="'error-button-' + i" (click)="onButtonClick(button)">
          {{ button.label | translate }}
        </pbb-button>
        }
      }
    </div>  
  </div>
</div>
